'use strict';


export default {
	method: 'POST',
	getUrl: getUrl,
};


function getUrl($incident) {
	return 'incident/' + $incident.uuid + '/daupler/incidents/calls/tasks/named_generic_form_team/request_by_groups/';
}
